import React, { useEffect, useState } from 'react';
import {
  ChevronLeft,
} from 'react-bootstrap-icons';
import styles from './invoice_detail_view.module.css';
import { ActivityIconBlue, AIChatIcon2, EditIcon, LockIcon, PrintIcon, TrashIcon } from '../../../../components/protected/Icons/IconsLib';
import { ActionButton, Content, Dialog, DialogTrigger, Flex, Item, Link, Menu, MenuTrigger, TabList, TabPanels, Tabs, ToastQueue, View } from '@adobe/react-spectrum';
import moment from 'moment';
import { invokeFinderApp } from '../../../../utils/NavigationUtils';
import { useTranslation } from 'react-i18next';
import { Key } from '@react-types/shared';
import PrintDialog from '../../../../components/protected/layout-components/HeaderToolbar/component/PrintDialog/PrintDialog';
import AddInvoiceDetail from './formSections/InvoiceDetailSection';
import AddSupplierDetail from './formSections/InvoiceSupplierSection';
import AddBankInfo from './formSections/InvoiceBankSection';
import InvoiceShippingSection from './formSections/InvoiceShippingSection';
import InvoiceFinanceSection from './formSections/InvoiceFinanceSection';
import InvoiceCustomAttributesSection from './formSections/InvoiceCustomAttributes';
import InvoiceCommentSection from './formSections/InvoiceCommentSection';
import InvoiceCustomerSection from './formSections/InvoiceCustomerSection';
import InvoiceTransactionComponent from './formSections/InvoiceITransactionSection';
import { InvoiceStatusDropDown } from './InvoiceStatusDropDown';
import InvoiceDocumentsView from './InvoiceDocumentsView';
interface IInvoiceDetailViewProps {
  selectedInvoice: any;
  invoiceStatusList: any[];
  printType?: string;
  onEdit?: (item: boolean) => void;
  onDelete?: (item: any) => void;
  onTool?: (item: any) => void;
  onAI?: (item: any) => void;
  onCopy?: (item: any) => void;
  onMove?: (item: any) => void;
  selectedItem?: any;
  handleBackClick?: () => void;
  SELECTED_INVOICE?: any;
  isFullScreen?: boolean;
  onStatusChange?: (statusId: string) => void;
  onRefreshInvoice?: () => Promise<void> | void;
}
const InvoiceDetailView: React.FC<IInvoiceDetailViewProps> = ({
  selectedInvoice,
  invoiceStatusList,
  printType, onEdit, onDelete, onTool, onAI, selectedItem, onCopy, onMove, handleBackClick, SELECTED_INVOICE, isFullScreen = false
  , onStatusChange
  , onRefreshInvoice
}) => {
  let [invoice, setInvoice] = useState<any>();
  const [useCompactHeader, setUseCompactHeader] = useState(false);
  const { t } = useTranslation('invoice');
  const _t = (key: string) => t(`invoice_detail.${key}`, { ns: 'invoice' });

  useEffect(() => {
    if (selectedInvoice) {
      setInvoice(selectedInvoice);
    }
  }, [selectedInvoice]);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const updateHeaderMode = () => {
      setUseCompactHeader(window.innerWidth < 768);
    };

    updateHeaderMode();
    window.addEventListener('resize', updateHeaderMode);
    return () => window.removeEventListener('resize', updateHeaderMode);
  }, []);

  const extraMenuItems = [
    { key: 'copy', name: _t('copy_link') }
  ];

  const responsiveMenuItems = [
    // { key: 'edit', name: _lt('edit') },
    { key: 'tool', name: 'Tool' },
    // { key: 'delete', name: _lt('delete') },
    { key: 'ai', name: 'AI' },
    ...extraMenuItems,
  ];

  const mobileOverflowMenuItems = [
    { key: 'ai', name: 'AI' },
    { key: 'tool', name: 'Tool' },
    ...extraMenuItems,
  ];

  const handleEditClicked = () => {
    if (onEdit) {
      onEdit(true);
    }
  };

  const handleDeleteClicked = () => {
    if (onDelete) {
      onDelete(invoice);
    }
  };

  const handleToolClicked = () => {
    if (onTool) {
      onTool(invoice);
    }
  };

  const handleAIClicked = () => {
    if (onAI) {
      onAI(invoice);
    }
  };

  const handleMenuClicked = (key: Key) => {
    if (key === 'ai') {
      handleAIClicked();
    }  else if (key === 'edit') {
      handleEditClicked();
    } else if (key === 'tool') {
      handleToolClicked();
    } else if (key === 'delete') {
      handleDeleteClicked();
    } else if (key === 'copy') {
      copyUrl();
    } else if (key === 'move') {
      if (onMove) {
        onMove(invoice);
      }
    }
  };

  const copyUrl = () => {
    const url = new URL(window.location.href);
    if (invoice?.id !== undefined && invoice?.id !== null) {
      url.searchParams.set('id', String(invoice.id));
    }
    navigator.clipboard.writeText(url.toString());
    ToastQueue.positive(t('link_copied_to_clipboard', { ns: 'layout_components' }), { timeout: 1000 });
  }

  const renderContextTrail = () => (
    <>
      {invoice?.folderName && (
        <Link
          UNSAFE_className={styles.folder_name_link}
          onPress={() => invokeFinderApp(invoice.folder, 'folder')}
        >
          {invoice.folderName}
        </Link>
      )}

      {invoice?.folderName && (invoice?.projectName || invoice?.ProjectName || invoice?.activityName) && (
        <span> &gt; </span>
      )}

      {(invoice?.projectName || invoice?.ProjectName) && (
        <Link
          UNSAFE_className={styles.folder_name_link}
          onPress={() => invokeFinderApp(invoice.project, 'project')}
        >
          {invoice.projectName || invoice.ProjectName}
        </Link>
      )}

      {(invoice?.projectName || invoice?.ProjectName) && invoice?.activityName && <span> &gt; </span>}

      {invoice?.activityName && (
        <Link
          UNSAFE_className={styles.folder_name_link}
          onPress={() => invokeFinderApp(invoice.activity, 'activity')}
        >
          {invoice.activityName}
        </Link>
      )}
    </>
  );

  const renderActionIcons = () => (
    <>
      <div className={styles.atollon_icon} onClick={handleAIClicked}>
        <AIChatIcon2 size={32} />
      </div>
      <div className={styles.tool_icon} onClick={handleToolClicked}>
        <LockIcon size={32} />
      </div>
    </>
  );

  const renderPrintTrigger = (size: number = 32) => (
    <div className={styles.print_icon}>
      <DialogTrigger type="popover">
        <ActionButton UNSAFE_style={{ border: 'none' }}>
          <PrintIcon size={size} />
        </ActionButton>
        <Dialog>
          <Content>
            <PrintDialog
              selectedItem={{
                ...invoice,
                type: printType || invoice?.type || '',
              }}
              print_type={printType || invoice?.type || ''}
            />
          </Content>
        </Dialog>
      </DialogTrigger>
    </div>
  );

  const renderPrimaryActions = (iconSize: number = 32) => (
    <>
      <div className={styles.edit_icon} onClick={handleEditClicked}>
        <EditIcon size={iconSize} />
      </div>
      <div className={styles.delete_icon} onClick={handleDeleteClicked}>
        <TrashIcon size={iconSize} />
      </div>
      {renderPrintTrigger(iconSize)}
    </>
  );

  const renderMobileHeader = () => (
    <View UNSAFE_className={`${styles.header_main} ${styles.mobile_header_main}`}>
        <Flex direction="column" gap="size-150">
          <Flex alignItems="center" justifyContent="space-between" gap="size-100" UNSAFE_className={styles.mobile_header_top_row}>
            <View UNSAFE_className={styles.mobile_status_wrap}>
              <InvoiceStatusDropDown
                statusArray={Array.isArray(invoiceStatusList) ? invoiceStatusList : []}
                selectedStatus={String(invoice?.state ?? '')}
                onStatusChange={(statusId) => {
                  setInvoice((prev: any) => {
                    if (!prev) return prev;
                    const selectedStatusObj = (invoiceStatusList || []).find((s: any) => String(s?.id) === String(statusId));
                    return {
                      ...prev,
                      state: statusId,
                      stateName: selectedStatusObj?.name || prev?.stateName,
                    };
                  });
                  onStatusChange?.(statusId);
                }}
              />
            </View>
            <Flex alignItems="center" gap="size-50" UNSAFE_className={styles.mobile_header_actions}>
              {renderPrimaryActions(28)}
              <MenuTrigger>
                <ActionButton UNSAFE_style={{ border: 'none' }}>...</ActionButton>
                <Menu items={mobileOverflowMenuItems} onAction={handleMenuClicked}>
                  {item => <Item key={item.key}>{item.name}</Item>}
                </Menu>
              </MenuTrigger>
            </Flex>
          </Flex>

        <Flex direction="column" gap="size-100" UNSAFE_className={styles.mobile_header_title_wrap}>
          <Flex alignItems="center" gap="size-100">
            {handleBackClick && (
              <ActionButton isQuiet onPress={handleBackClick} UNSAFE_className={styles.back_button}>
                <ChevronLeft size={20} />
              </ActionButton>
            )}
            <ActivityIconBlue size={22} />
            <b title={invoice?.journalName} className={`${styles.activity_name} ${styles.mobile_activity_name}`}>
              {invoice?.journalName?.length > 40 ? `${invoice?.journalName.substring(0, 40)}...` : invoice?.journalName}
            </b>
          </Flex>
        </Flex>

        {(invoice?.folderName || invoice?.projectName || invoice?.ProjectName || invoice?.activityName) && (
          <View UNSAFE_className={styles.mobile_context_row}>
            {renderContextTrail()}
          </View>
        )}

        {(invoice?.invoiceNumber || invoice?.created || invoice?.modified) && (
          <Flex gap="size-100" wrap UNSAFE_className={styles.mobile_meta_row}>
            {invoice?.invoiceNumber && (
              <View UNSAFE_className={styles.mobile_meta_chip}>
                {_t('id')}: {invoice.invoiceNumber}
              </View>
            )}
            {invoice?.created && (
              <View UNSAFE_className={styles.mobile_meta_chip}>
                {_t('created')}: {moment(invoice.created).format('DD-MM-YYYY')}
              </View>
            )}
            {invoice?.modified && (
              <View UNSAFE_className={styles.mobile_meta_chip}>
                {_t('modified')}: {moment(invoice.modified).format('DD-MM-YYYY')}
              </View>
            )}
          </Flex>
        )}

      </Flex>
    </View>
  );

  return (
    <Flex width="100%" direction={'column'}>
      <Flex width="100%" direction={'column'} UNSAFE_style={isFullScreen ? { padding: '10px' } : undefined}>
        {isFullScreen && useCompactHeader ? renderMobileHeader() : <View UNSAFE_className={styles.header_main}>
          <View UNSAFE_className={styles.header_child}>
            <View UNSAFE_className={styles.header_top_row}>
              <View UNSAFE_className={styles.frame_parent}>
                <View UNSAFE_className={styles.icon_activity_parent}>
                  {handleBackClick &&
                    <ActionButton isQuiet onPress={handleBackClick} UNSAFE_className={styles.back_button}>
                      <ChevronLeft size={20} />
                    </ActionButton>
                  }
                  <ActivityIconBlue size={25} />
                  <b title={invoice?.journalName} className={styles.activity_name}>
                    {invoice?.journalName?.length > 55 ? invoice?.journalName.substring(0, 55) + '...' : invoice?.journalName}
                  </b>
                </View>
                {(invoice?.folderName || invoice?.projectName || invoice?.ProjectName || invoice?.activityName) && (
                  <View UNSAFE_className={styles.folder_name_parent}>
                    <View UNSAFE_className={styles.folder_name}>
                      {renderContextTrail()}
                    </View>
                  </View>
                )}
              </View>
              <View UNSAFE_className={styles.icon_list_parent}>
                <View UNSAFE_style={{ marginRight: '10px' }}>
                  <InvoiceStatusDropDown
                    statusArray={Array.isArray(invoiceStatusList) ? invoiceStatusList : []}
                    selectedStatus={String(invoice?.state ?? '')}
                    onStatusChange={(statusId) => {
                      setInvoice((prev: any) => {
                        if (!prev) return prev;
                        const selectedStatusObj = (invoiceStatusList || []).find((s: any) => String(s?.id) === String(statusId));
                        return {
                          ...prev,
                          state: statusId,
                          stateName: selectedStatusObj?.name || prev?.stateName,
                        };
                      });
                      onStatusChange?.(statusId);
                    }}
                  />
                </View>
                <View UNSAFE_className={styles.icon_list_child}>
                  <View UNSAFE_className={styles.desktop_primary_actions}>
                    {renderPrimaryActions()}
                  </View>
                  <View UNSAFE_className={styles.desktop_action_icons}>
                    {renderActionIcons()}
                  </View>
                  <View UNSAFE_className={styles.desktop_extra_menu}>
                    <MenuTrigger>
                      <ActionButton UNSAFE_style={{ border: 'none' }}>...</ActionButton>
                      <Menu items={extraMenuItems} onAction={handleMenuClicked}>
                        {item => <Item key={item.key}>{item.name}</Item>}
                      </Menu>
                    </MenuTrigger>
                  </View>
                  <View UNSAFE_className={styles.responsive_overflow_menu}>
                    <MenuTrigger>
                      <ActionButton UNSAFE_style={{ border: 'none' }}>...</ActionButton>
                      <Menu items={responsiveMenuItems} onAction={handleMenuClicked}>
                        {item => <Item key={item.key}>{item.name}</Item>}
                      </Menu>
                    </MenuTrigger>
                  </View>
                </View>
              </View>
            </View>
            {(invoice?.invoiceNumber || invoice?.created || invoice?.modified) &&
              <Flex direction={'row'} gap={'size-100'}>
                <View UNSAFE_className={styles.tag_parent} marginTop={'27px'}>
                  {invoice?.invoiceNumber && (
                    <Content UNSAFE_style={{ fontSize: '14px' }}>
                      <Flex direction={'row'} alignItems={'center'} justifyContent={'center'} UNSAFE_className={styles.footer_wrapper}>
                        <Flex direction={'row'} alignItems={'center'} justifyContent={'center'} gap={'6px'}>
                          <View position={'relative'} UNSAFE_className={styles.footer_text_1}>
                            <span title={invoice.invoiceNumber}>{_t('id')}</span>
                          </View>
                          <View position={'relative'} width={'2px'} height={'20px'} UNSAFE_className={styles.pipe_sign}></View>
                          <div className={styles.footer_text_1}>{invoice.invoiceNumber} </div>
                        </Flex>
                      </Flex>
                    </Content>
                  )}
                  {invoice?.created && (
                    <Flex direction={'column'}>
                      <Content UNSAFE_style={{ fontSize: '14px' }}>
                        {_t('created')}
                      </Content>
                      <Content UNSAFE_style={{ fontSize: '14px' }}>
                        <Flex direction={'row'} alignItems={'center'} justifyContent={'center'} gap={'6px'}>
                          <View position={'relative'} UNSAFE_className={styles.footer_text_1}>
                            <span title={invoice.created}>{moment(invoice.created).format('DD-MM-YYYY')}</span>
                          </View>
                        </Flex>
                      </Content>
                    </Flex>
                  )}
                  {invoice?.modified && (
                    <Flex direction={'column'}>
                      <Content UNSAFE_style={{ fontSize: '14px' }}>
                        {_t('modified')}
                      </Content>
                      <Content UNSAFE_style={{ fontSize: '14px' }}>
                        <Flex direction={'row'} alignItems={'center'} justifyContent={'center'} gap={'6px'}>
                          <View position={'relative'} UNSAFE_className={styles.footer_text_1}>
                            <span title={invoice.created}>{moment(invoice.modified).format('DD-MM-YYYY')}</span>
                          </View>
                        </Flex>
                      </Content>
                    </Flex>
                  )}
                </View>
              </Flex>
            }
          </View>
        </View>}
      </Flex>
      <View height={'100vh'} width={'100%'} UNSAFE_style={isFullScreen ? { paddingLeft: '15px', paddingRight: '15px' } : undefined}>
        <Tabs aria-label={t('invoice_detail_aria', { ns: 'invoice', defaultValue: 'Invoice detail' })} isEmphasized>
          <TabList>
            <Item key="overview">{_t('overview')}</Item>
            <Item key="communication">{_t('communication')}</Item>
            <Item key="documents">{_t('documents')}</Item>
          </TabList>
          <TabPanels>
            <Item key="overview">
              <Flex direction={'row'} gap={'size-100'}>
                <AddInvoiceDetail SELECTED_INVOICE={SELECTED_INVOICE} isEdit={false} invoice={invoice} onChange={setInvoice} />
              </Flex>
              <Flex direction={'row'} gap={'size-100'}>
                <AddSupplierDetail invoice={invoice} isEdit={false} onChange={setInvoice} />
                <AddBankInfo invoice={invoice} isEdit={false} onChange={setInvoice} />
              </Flex>
              <Flex direction={'row'} gap={'size-100'}>
                <InvoiceCustomerSection invoice={invoice} isEdit={false} onChange={setInvoice} />
                <InvoiceShippingSection invoice={invoice} isEdit={false} onChange={setInvoice} />
              </Flex>
              <Flex direction={'row'} gap={'size-100'}>
                <InvoiceFinanceSection invoice={invoice} isEdit={false} onChange={setInvoice} />
                <InvoiceCustomAttributesSection invoice={invoice} isEdit={false} onChange={setInvoice} />
              </Flex>
              <Flex>
                <InvoiceCommentSection invoice={invoice} isEdit={false} onChange={setInvoice} />
              </Flex>
              <Flex gap={'size-100'} marginTop={'size-100'} width={'100%'}>
                <InvoiceTransactionComponent invoice={invoice} isEdit={false} onInvoiceChange={setInvoice} />
              </Flex>
            </Item>
            <Item key="communication">
              <></>
            </Item>
            <Item key="documents">
              <InvoiceDocumentsView invoice={invoice} onRefreshInvoice={onRefreshInvoice} />
            </Item>
          </TabPanels>
        </Tabs>
      </View>
    </Flex>
  );
};

export default InvoiceDetailView;
